
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weekly-planning-reports",
      function () {
        return require("private-next-pages/weekly-planning-reports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weekly-planning-reports"])
      });
    }
  